<template>
    <div class="w-full">
        <nav class="sm:hidden">
            <a      v-show="navInformation.back"
                    :href="navInformation.back"
                    class="flex items-center text-sm leading-5 font-medium text-gray-600 hover:text-gray-900 plain-link">
                <svg class="shrink-0 -ml-1 mr-1 h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd"
                          d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                          clip-rule="evenodd"/>
                </svg>
                Back
            </a>
        </nav>
        <nav class="hidden sm:flex items-center text-sm leading-5 font-medium">
            <div    v-for="(link, text) in navInformation.links"
                    class="">
                <a      :href="link"
                        class="text-gray-500 hover:text-gray-700 plain-link">
                    {{ text }}
                </a>
                <svg class="shrink-0 mx-2 h-5 w-5 text-gray-400 inline" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd"
                          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                          clip-rule="evenodd"/>
                </svg>
            </div>

            <a  class="text-gray-600 hover:text-gray-900 cursor-default">
                {{ navInformation.end }}
            </a>
        </nav>
    </div>
</template>

<script>

export default {
    name: "TopNav",
    mixins: [],
    props: {
        navInformation: Object,
    },
    data() {
        return {

        }
    },
}
</script>

<style scoped>

</style>